var React = require('react');

function GreenArrowInline (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"20","cy":"20","r":"20","key":0}),React.createElement("path",{"d":"M31.0607 21.0607C31.6464 20.4749 31.6464 19.5251 31.0607 18.9393L21.5147 9.3934C20.9289 8.80761 19.9792 8.80761 19.3934 9.3934C18.8076 9.97918 18.8076 10.9289 19.3934 11.5147L27.8787 20L19.3934 28.4853C18.8076 29.0711 18.8076 30.0208 19.3934 30.6066C19.9792 31.1924 20.9289 31.1924 21.5147 30.6066L31.0607 21.0607ZM10 21.5H30V18.5H10V21.5Z","fill":"white","key":1})]);
}

GreenArrowInline.defaultProps = {"width":"40","height":"40","viewBox":"0 0 40 40"};

module.exports = GreenArrowInline;

GreenArrowInline.default = GreenArrowInline;
